import { gql } from '@apollo/client';

export const PARSER_DATA = gql`
  query parser($id: ID!) {
    parser(id: $id) {
      filterErrors
      log
      logSample
      name
      content
      id
      logCount
      type
    }
  }
`;

export const UPDATE_PARSER_SAMPLE = gql`
  mutation updateParserSample($filter: String!, $id: ID!) {
    updateParserSample(filter: $filter, id: $id) {
      logSample
    }
  }
`;

export const TEST_PARSER = gql`
  mutation testParser($testData: String!, $textContent: String!, $showDetailedOutput: Boolean!) {
    testParser(testData: $testData, textContent: $textContent, showDetailedOutput: $showDetailedOutput) {
      log
    }
  }
`;

export const ADD_PARSER = gql`
  mutation addParser($parserName: String!, $textContent: String) {
    addParser(parserName: $parserName, textContent: $textContent) {
      id
      content
    }
  }
`;

export const FORMAT_PARSER = gql`
  mutation formatParser($id: ID!, $content: String!) {
    formatParser(id: $id, content: $content)
  }
`;
